import { Delete, Edit, TramSharp } from '@mui/icons-material'
import { IconButton } from '@mui/material'
import React, { useContext } from 'react'
import { TiposServicioContext } from '../../pages/catalogos/ServiciosTipoPage';

export const TipoServicioComponent = ({tipoServicio}) => {
  const {modalAgregaTipoServicio, setModalAgregaTipoServicio, modalEliminaTipoServicio, setModalEliminaTipoServicio, obtenerTipos,tipoServicioSel, setTipoServicioSel} = useContext(TiposServicioContext);

  return (
    <div
      style={{
        display:'flex',
        flexDirection:'row',
        justifyContent:'space-between',
        marginTop:6,
        backgroundColor:'white',
        borderRadius:10,
        padding:5,
        alignItems:'center'
      }}
    >
      <div
        style={{
          fontSize:14,
          
        }}
      >
        {tipoServicio.descripcion}
      </div>
      <div>
      <IconButton
        onClick={() => {
          setModalAgregaTipoServicio(true);
          setTipoServicioSel(tipoServicio)
        }}
      >
        <Edit style={{color:'green'}} />
      </IconButton>
      <IconButton
        onClick={() => {
          setModalEliminaTipoServicio(true);
          setTipoServicioSel(tipoServicio)
        }}
      >
        <Delete style={{color:'red'}} />
      </IconButton>
      </div>
    </div>
  )
}
